/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Thai (Thailand)
export default {
  'confluence-table-tree.column.contributors': 'ผู้สนับสนุน',
  'confluence-table-tree.column.last-modified': 'แก้ไขครั้งล่าสุด',
  'confluence-table-tree.column.title': 'ชื่อ',
  'confluence-table-tree.could-not-load': 'ไม่สามารถโหลดได้',
  'confluence-table-tree.could-not-load-contributors': 'ไม่สามารถโหลดผู้สนับสนุนได้',
  'confluence-table-tree.create-child-page': 'จัดทำหน้าข้อมูลรอง',
  'confluence-table-tree.create-page': 'สร้างหน้าข้อมูล',
  'confluence-table-tree.default.page.title': 'ไม่มีชื่อ',
  'confluence-table-tree.default.show-all-pages-button.label': 'แสดงหน้าข้อมูลเพิ่มเติม',
  'confluence-table-tree.draft.lozenge': 'แบบร่าง',
  'confluence-table-tree.draft.tooltip': 'คุณสามารถดูแบบร่างได้เพียงคนเดียว',
  'confluence-table-tree.drafts-toggle.label': 'แสดงแบบร่าง',
  'confluence-table-tree.edit': 'แก้ไข',
  'confluence-table-tree.edit-in-confluence': 'แก้ไขใน Confluence',
  'confluence-table-tree.empty.description':
    'สร้างบันทึกการประชุม ความต้องการด้านผลิตภัณฑ์ การตัดสินใจ หรือเนื้อหาอื่น ๆ เพื่อดูการเติมเต็มเนื้อหาในพื้นที่นี้',
  'confluence-table-tree.empty.title': 'ทุกสิ่งสามารถเป็นไปได้ที่นี่',
  'confluence-table-tree.error.description': 'เราไม่สามารถแสดงหน้าข้อมูลเหล่านี้ให้คุณได้ โปรดลองอีกครั้งในภายหลัง',
  'confluence-table-tree.error.row': 'ไม่สามารถโหลดหน้าข้อมูลได้',
  'confluence-table-tree.error.title': 'แย่จัง',
  'confluence-table-tree.friendly-when-created': 'สร้างแล้ว',
  'confluence-table-tree.friendly-when-updated': 'อัปเดตแล้ว',
  'confluence-table-tree.share.copied': 'คัดลอกลงคลิปบอร์ดแล้ว',
  'confluence-table-tree.share.copy-button': 'คัดลอก',
  'confluence-table-tree.share.subtitle': 'แชร์ลิงก์นี้',
  'confluence-table-tree.share.title': 'แชร์หน้าข้อมูล',
  'confluence-table-tree.share.tooltip': 'แชร์',
  'confluence-table-tree.view-profile': 'ดูโปรไฟล์',
};
